import script from "./MaterialLimitsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialLimitsTable.vue?vue&type=script&setup=true&lang=js"

import "./MaterialLimitsTable.vue?vue&type=style&index=0&id=7a92bfb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a92bfb2"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
